<!-- This page is pure junk.  Poynt collect could not be instantiated twice and all its call backs are internal so I loose scope with Vue the second time around  -->

<template>
  <div>
    <b-modal
      v-b-modal.modal-center
      id="askDelete"
      title="Remove Card"
      @ok="handleDelete"
    >
      Are you sure you want to remove this credit card?
    </b-modal>

    <b-modal
      ref="cardManagerModal"
      title="Card Manager"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class body-gray p-5"
      lazy
      @hidden="
        () => {
          $emit('closed');
        }
      "
      hide-footer
    >
      <div v-show="status == 'cardList'">
        <CardManagementCard
          :item="defaultCard"
          v-if="defaultCard"
          :selectedCard="selectedCard"
          @cardSelected="cardSelected"
          @deleteCard="deleteCard"
        ></CardManagementCard>

        <div v-for="item in cardsNoDefault" class="card-list">
          <CardManagementCard
            :item="item"
            :selectedCard="selectedCard"
            @cardSelected="cardSelected"
            @deleteCard="deleteCard"
          ></CardManagementCard>
        </div>
      </div>
      <div v-show="status == 'cardList'">
        <b-row>
          <b-col>
            <b-button
              class="btn-block mt-4"
              variant="primary"
              @click.prevent="addCard"
            >
              Add New Card
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div v-show="status == 'collectCard'">
        <div
          id="poyntErrors"
          class="alert alert-danger"
          style="display: none"
        ></div>

        <div
          class="card p-4 shadow-none"
          style="background-color:white"
          id="card-element"
          ref="cardElement"
        ></div>

        <b-button
          v-show="status == 'collectCard'"
          type="submit"
          variant="primary"
          class="btn-block mt-4"
          @click.prevent="getNonce"
          >Add Card</b-button
        >
      </div>

      {{ t }}
    </b-modal>
  </div>
</template>
<script>
import CardSvgLarge from "./CardSvgLarge";
import CardManagementCard from "./CardManagementCard";
export default {
  props: {
    customerSavedCards: null,
    customer: null,
    selectedCard: null,
    showManageCards: false,
  },
  components: { CardSvgLarge, CardManagementCard },
  watch: {
    showManageCards(newVal, oldVal) {
      if (newVal) {
        this.$refs.cardManagerModal.show();
        this.cards = JSON.parse(JSON.stringify(this.customerSavedCards));

        if (this.cards.length == 0) {
          this.addCard();
        } else {
          this.status = "cardList";
        }
      } else {
        this.$refs.cardManagerModal.hide();
      }
    },
  },
  data: function() {
    return {
      fieldErrors: [],
      cards: [],
      status: "cardList",
      poyntError: null,
      deleteCardSelected: null,
      newCardDefault: true,
      script: "https://cdn.poynt.net/collect.js",
      t: null,
    };
  },
  created() {
    window.customer = this.customer; // long story
  },
  computed: {
    cardsNoDefault() {
      return this.cards.filter(function(item) {
        return !item.isDefault;
      });
    },
    defaultCard() {
      return this.cards.find(function(item) {
        return item.isDefault;
      });
    },
  },
  methods: {
    hide() {
      var self = this;
      self.$bvModal.hide("poyntModal");
    },
    cancel() {
      var self = this;
    },
    addCard() {
      var self = this;

      self.status = "collectCard";
      self.$nextTick(() => {
        self.collect();
      });
    },
    deleteCard(card) {
      this.deleteCardSelected = card;
      this.$bvModal.show("askDelete");
    },
    async handleDelete() {
      var result = await this.$client.post(
        "/api/customerSavedCard/InActivate",
        {
          Id: this.deleteCardSelected.id,
          customerId: this.customer.id,
        }
      );

      if (result.data.isSuccess) {
        if (result.data.value.hasMembershipPaymentPlans) {
          this.$emitter.emit("noSuccess-confirm", {
            title: "Associated Card",
            message:
              "This card is associated with an active payment plan or membership.",
          });
          return;
        }

        if (this.cards.length == 0) {
          this.addCard();
        } else {
          this.status = "cardList";
        }

        this.$emitter.emit("success", {
          title: "Deleted",
          message: "The selected card has been deleted.",
        });

        //delete the card locally
        this.cards = this.cards.filter(
          (e) => e.id != this.deleteCardSelected.id
        );

        if (this.cards.length == 0) this.addCard();

        //delete the card customer saved cards.  Each component is responsible for updating the customerSavedCards
        this.$emit("cardDeleted", this.deleteCardSelected);
      }
    },
    async cardSelected(card) {
      var r = await this.$client.post("/api/customerSavedCard/makeDefault", {
        customerId: self.customer.id,
        Id: card.id,
      });

      if (r.data.isSuccess) {
        this.$emit("cardSelected", card);
      }
    },

    async getCards() {
      var response = await this.$client.get(
        "/api/customerSavedCard/customerSavedCards?customerId=" +
          self.customer.id
      );

      this.cards = response.data.value;
    },

    getNonce() {
      var self = this;

      window.t.getNonce({
        businessId: self.$localStorageService.getItem("businessId"),
        firstName: window.customer.firstName,
        lastName: window.customer.lastName,
      });
    },
    collect() {
      var self = this;
      self.fieldErrors = [];

      let x = document.getElementById("poyntErrors");
      x.innerHTML = "";
      x.style.display = "none";

      self.collectFactory(function() {
        const options = {
          iFrame: {
            width: "100%",

            border: "0px",
          },
          style: {
            theme: "customer", // basic default theme,
            // theme: "customer", (alternative default theme)
          },
          displayComponents: {
            firstName: false, // toggle these to true if you wish to show the forms
            lastName: false,
            emailAddress: false,
            submitButton: false,
            zipCode: true,
            showEndingPage: false, // controls ending page,
            labels: true,
          },
          additionalFieldsToValidate: ["zip"], // which fields to validate,
        };

        self.$refs.cardElement.innerHTML = "";

        window.t.mount("card-element", document, options);
      });
    },
    collectFactory(callback) {
      var self = this;

      if (!window.poyntCollect) {
        window.poyntCollect = document.createElement("script");
        window.poyntCollect.src =
          "https://cdn.poynt.net/collect.js";
        window.poyntCollect.async = false;

        window.poyntCollect.onload = () => {
          window.t = new TokenizeJs(
            self.$localStorageService.getItem("businessId"),
            self.$localStorageService.getItem("poyntAppId")
          );

          callback();

          window.t.on("nonce", async function(nonce) {
            var result = await self.$client.post(
              "/api/customerSavedCard/tokenize",
              {
                nonce: nonce.data.nonce,
                customerId: window.customer.id,
                isDefault: self.newCardDefault,
              }
            );

            if (result.data.isSuccess) {
              self.$emitter.emit("cardAdded", result.data.value);
            }
          });
          window.t.on("error", function(err) {
            let x = document.getElementById("poyntErrors");
            x.innerHTML = "Please make sure all field are correct";
            x.style.display = "block";
          });
        };

        document.head && document.head.appendChild(window.poyntCollect);
      } else {
        window.t.businessId = self.$localStorageService.getItem("businessId");
        callback();
      }
    },
  },
};
</script>

<style scoped>
.defaultCard {
  border-radius: 0.375rem;
}

.card-list {
  background: #fff;
  border-bottom: solid 1px #e9ecef;
  cursor: pointer;
}

.card-list:hover {
  background: #e9ecef;
}

.card-list:nth-child(2) {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  margin-top: 20px;
}

.card-list:last-child {
  border-bottom: none;
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
</style>
